// utilities
import { IFileReference } from "@iluvatar/global/src/typings";
import { isImage } from "@iluvatar/global/src/utilities";

import { imageVariantName } from "@iluvatar/global/src/utilities/image-variants";

// types
import { LocalFileRef, isRemoteFileRef } from "./types";

// internal types
type SizeWidth = number | string;
type SizeHeight = number | string;

export function imgRefSize(
  file: LocalFileRef | IFileReference | undefined,
  size: [SizeWidth, SizeHeight] | number,
  blurred = false,
): string | undefined {
  if (isRemoteFileRef(file) && file.ref && isImage(file.metadata.contentType)) {
    const objectPath = file.ref
      .replace(/^gs:\/\/[^/]+\//, "")
      .replace(/^\//, "");
    // Only profile images pass through the image processor and have variants.
    if (!/^users\/[^/]+\/images\/[^/]+$/.test(objectPath)) {
      return file.ref;
    }
    const [width, height] = Array.isArray(size) ? size : [size, size];
    const pathArr = file.ref.split("/");
    const fileName = pathArr.pop();
    const thumbnailRef = [
      ...pathArr,
      imageVariantName(fileName!, width, height, blurred),
    ].join("/");
    return thumbnailRef;
  }
  return undefined;
}

/** Select only an AVIF variant the processor has finished publishing. */
export function imgRefAvif(
  file: IFileReference | undefined,
): string | undefined {
  const jpeg = imgRefSize(file, 600);
  if (!jpeg || !file) {
    return;
  }
  const candidate = jpeg.replace(/\.[^/.]+$/, ".avif");
  const objectPath = candidate
    .replace(/^gs:\/\/[^/]+\//, "")
    .replace(/^\//, "");
  return file.metadata.transforms?.includes(objectPath) ? candidate : undefined;
}
